import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ProviderService } from '../service/provider.service';

@Injectable({
    providedIn: 'root'
})
export class ProviderValidators
{
    constructor(private providerService: ProviderService) { }

    public validateProviderNpiUnique(control: UntypedFormControl, initialName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialName !== control.value)
            {
                this.providerService.existsProviderNpi(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ npiExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
